import { FC, MouseEventHandler, ReactNode, useCallback } from 'react';
import { Button, ButtonProps } from 'antd';
import { Tooltip } from '../Tooltip';

interface DividerHeaderButtonProps extends ButtonProps {
  id: string;
  label: string;
  icon: ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  hasError?: boolean;
  disabled?: boolean;
}

export const DividerHeaderButton: FC<DividerHeaderButtonProps> = (props) => {
  const { id, label, icon, onClick, hasError, disabled, ...rest } = props;
  const handleButtonClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (event) => {
      event.stopPropagation();
      onClick?.(event);
    },
    [onClick],
  );

  if (!onClick) {
    return;
  }

  return (
    <Tooltip title={label}>
      <Button
        id={id}
        icon={icon}
        aria-label={label}
        onClick={handleButtonClick}
        danger={hasError}
        disabled={disabled}
        {...rest}
      />
    </Tooltip>
  );
};
